// Production-safe logging utility
const isDevelopment = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.port === '5173' ||
  process.env.NODE_ENV === 'development'
);

export const logger = {
  debug: (...args: any[]) => {
    if (isDevelopment) {
      console.debug('[DEBUG]', ...args);
    }
  },
  
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log('[LOG]', ...args);
    }
  },
  
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info('[INFO]', ...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn('[WARN]', ...args);
    } else {
      // In production, only log critical warnings
      console.warn('[WARN]', ...args);
    }
  },
  
  error: (...args: any[]) => {
    // Always log errors, even in production
    console.error('[ERROR]', ...args);
    
    // In production, you might want to send to error tracking service
    if (!isDevelopment) {
      // TODO: Send to error tracking service like Sentry
      // Sentry.captureException(args[0]);
    }
  },
  
  // Auth-specific logging
  auth: (...args: any[]) => {
    if (isDevelopment) {
      console.log('[AUTH]', ...args);
    }
  },
  
  // API-specific logging  
  api: (...args: any[]) => {
    if (isDevelopment) {
      console.log('[API]', ...args);
    }
  }
};

// Export individual methods for convenience
export const { debug, log, info, warn, error, auth, api } = logger;

// Production performance logging
export const performanceLogger = {
  startTimer: (label: string) => {
    if (isDevelopment) {
      console.time(label);
    }
  },
  
  endTimer: (label: string) => {
    if (isDevelopment) {
      console.timeEnd(label);
    }
  },
  
  mark: (label: string) => {
    if (isDevelopment && performance.mark) {
      performance.mark(label);
    }
  }
};
